module.exports = __webpack_public_path__ + "static/media/playStoreQRCode.6f9e94d8.svg";